import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  modo;
  constructor(public router: Router) {}

  ngOnInit(): void {
    if (environment.MODO != 'PROD') {
      this.modo = environment.MODO;
    }
  }

  title = 'site-zemt';

  toTop() {
    return window.scrollTo(0, 0);
  }
}
